import { render, staticRenderFns } from "./StartChat.vue?vue&type=template&id=9e103096&scoped=true"
import script from "./StartChat.vue?vue&type=script&lang=js"
export * from "./StartChat.vue?vue&type=script&lang=js"
import style0 from "./StartChat.vue?vue&type=style&index=0&id=9e103096&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e103096",
  null
  
)

export default component.exports